<template>
  <div class="ChangeProductType">
    <div class="ChangeProductType_title" @click="ChangeProductTypeButton" v-if="highlightChangeProductType || greyChangeProductType">
      <p
        :class="{grey: greyChangeProductType}"
        @mouseover="mouseover()"
        @mouseleave="mouseleave()"
      >
        {{ $t('subscription_details.changeReplenishmentType.subTitle', 'Change product type') }}
      </p>
    </div>
    <v-popover
      v-if="!bundleType"
      trigger="manual"
      placement="bottom-end"
      :open="changeProductType"
      popover-wrapper-class="changeProductType_poptip"
    >
      <template slot="popover">
        <div>{{ $t('subscription_details.accordion.shippingConfirmed.popUp.message', 'This feature is currently unavailable, as we are still processing your order') }}</div>
      </template>
    </v-popover>
    <v-popover
      v-if="bundleType"
      trigger="manual"
      placement="bottom-end"
      :open="changeProductType"
      popover-wrapper-class="changeOnlyReplenishmentType_poptip"
    >
      <template slot="popover">
        <div>{{ $t('subscription_details.accordion.shippingConfirmed.popUp.message', 'This feature is currently unavailable, as we are still processing your order') }}</div>
      </template>
    </v-popover>
    <app-modal name="ChangeProductType" width="546px" height="558px" @after-closed="emptyCancelData">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.changeReplenishmentType.title', 'Modify subscription') }}
        </h3>
        <div class="modal-content">
          <div class="ChangeProductType_productItems">
            <h3>{{ $t('subscription_details.changeReplenishmentType.subTitle', 'Change product type') }}</h3>
            <ul class="flex justify-content-start">
              <li
                v-for="(productItem, index) in replenishmentOptions"
                :key="index"
                @click="selectedProduct(productItem.id)"
                :class="activeProductItem == productItem.id ? 'active_product': ''"
                :ref="productItem.id"
                :id="productItem.id">
                <div class="image"><img :src="productItem.imageUrl" :alt="productItem.name"></div>
                <h4>{{ productItem.name }}</h4>
                <p v-if="productItem.paymentBillingPeriod === 'Month'">
                  <span>{{ productItem.paymentAmount | formatCurrency(true) }}</span>
                  <span> / {{ $t('common.product.price.monthlyCharge', 'monthly charge') }}</span>
                </p>
                <p v-if="productItem.paymentBillingPeriod === 'Quarter'">
                  <span>{{ productItem.paymentAmount | formatCurrency(true) }}</span>
                  <span> / {{ $t('common.product.price.quarterlyCharge', 'quarterly Charge') }}</span>
                </p>
                <p v-if="productItem.paymentBillingPeriod === 'SemiAnnual'">
                  <span>{{ productItem.paymentAmount | formatCurrency(true) }}</span>
                  <span> / {{ $t('common.product.price.semiAnnual', 'Semi annual') }}</span>
                </p>
                <!-- <p v-if="productItem.paymentBillingPeriod === 'SpecificMonths'">
                  <span>{{ productItem.paymentSpecificMonthAmount | formatCurrency(true) }}</span>
                  <span> / {{ $t('common.product.price.specificMonths', 'months') }}</span>
                </p> -->
                <p v-if="productItem.paymentBillingPeriod === 'SpecificMonths'">
                  <span> {{productItem.paymentAmount  | formatCurrency(true) }} </span>
                  <span> / {{productItem.paymentSpecificMonthAmount}}{{ $t('common.product.price.specificMonths', 'months') }}</span>
                </p>

              </li>
            </ul>
          </div>
          <div class="modal-button-warpper">
            <app-button
              class="cancel_closeModal"
              @click.prevent="cancelChangeProductType"
            >
              {{ $t('subscription_details.changeReplenishmentType.button.cancel', 'Cancel') }}
            </app-button>

            <app-button
              class="cancel_openModal"
              :disabled="!activeProductItem"
              @click.prevent="modifyChangeProductType"
            >
              {{ $t('subscription_details.changeReplenishmentType.button.updateSubscription', 'Update subscription') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
    <app-modal name="confirmChangeProduct" width="546px" height="600px" @after-closed="emptyCancelData">
      <div class="v--modal-content">
        <h3 class="modal-title">
          {{ $t('subscription_details.changeReplenishmentType.confirm.title', 'Confirm changes to your subscription') }}
        </h3>
        <div class="modal-content">
          <div class="ChangeProductType_productItems">
            <p class="ChangeProductType_productItems_title">
              {{ $t('subscription_details.changeReplenishmentType.confirm.subTitle.tips', 'This is what your') }}
              <b>{{ activeProductInfo.name }}</b>
              {{ $t('subscription_details.changeReplenishmentType.confirm.subTitle.subTips', 'brush head subscription will look like.') }}
            </p>
            <product
              :image="activeProductInfo.imageUrl"
              :active-product-number="subscriptionNumber"
              :active-product-info="activeProductInfo"
              :active-product-payment-date="activeProductPaymentDate"
            >
              <template slot="popup-information-title">
                <h3 class="product-summary-title">{{ $t('subscription_details.changeReplenishmentType.confirm.title.summary', 'Summary') }}</h3>
              </template>
            </product>
            <app-modal name="newReplenishment">
              <div class="v--modal-content" v-html="activeProductInfo.termsText"></div>
            </app-modal>
            <p class="ChangeProductType_productItems_bottom">
              {{ $t('subscription_details.changeReplenishmentType.confirm.terms.tipsOne', 'The') }}
              <a
                href="##"
                class="link"
                @click.prevent="$bus.$emit('open-modal', 'newReplenishment')">
                {{ $t('subscription_details.changeReplenishmentType.confirm.terms.text', 'Terms & Conditions') }}
              </a>
              {{ $t('subscription_details.changeReplenishmentType.confirm.terms.tipsTwo', 'for your subscription remain unchanged.') }}
            </p>
            <p class="ChangeProductType_productItems_bottom">
              {{ $t('subscription_details.changeReplenishmentType.confirm.terms.tipsThree', 'Please note that you can only change your subscription again after the next shipment.') }}
            </p>
          </div>
          <div class="modal-button-warpper">
            <app-button
              class="cancel_closeModal"
              @click.prevent="cancelConfirmChangeProductType"
            >
              {{ $t('subscription_details.changeReplenishmentType.button.cancel', 'Cancel') }}
            </app-button>

            <app-button
              class="cancel_openModal"
              @click.prevent="confirmChangeProductTask.run()"
              :is-loading="confirmChangeProductTask.isActive"
            >
              {{ $t('subscription_details.changeReplenishmentType.button.confirm', 'Confirm') }}
            </app-button>
          </div>
        </div>
      </div>
    </app-modal>
  </div>
</template>
<script>
  import { find } from 'lodash'
  import Product from 'components/Product'
  import Vue from 'vue'
  import { extractErrorMessage } from '@/utilities/common'
  export default {
    name: 'replenishment-change-product-type',

    data () {
      return {
        activeProductItem: '',
        activeProductInfo: {},
        changeProductType: false,
        displayChangeReplenishmentSuccessTip: {}
      }
    },

    props: {
      subscriptionNumber: {
        type: String,
        default: null
      },
      replenishmentOptions: {
        type: Array,
        default: function () {
          return []
        }
      },
      ableToChangeReplenishment: {
        type: Boolean,
        default: false
      },
      bundleType: {
        type: Boolean,
        default: false
      }
    },

    computed: {
      highlightChangeProductType () {
        return this.replenishmentOptions.length > 0 && this.ableToChangeReplenishment
      },
      greyChangeProductType () {
        return this.replenishmentOptions.length > 0 && !this.ableToChangeReplenishment
      },

      activeProductPaymentDate () {
        return `${new Date(this.activeProductInfo.nextPaymentDate).toDateString().split(' ')[1]} ${new Date(this.activeProductInfo.nextPaymentDate).getDate()}, ${new Date(this.activeProductInfo.nextPaymentDate).getFullYear()}`
      }
    },

    methods: {
      ChangeProductTypeButton () {
        if (this.highlightChangeProductType) {
          this.$bus.$emit('open-modal', 'ChangeProductType')
        }
      },

      selectedProduct (id) {
        this.activeProductItem = id
        this.activeProductInfo = find(this.replenishmentOptions, { id: this.activeProductItem })
      },

      emptyCancelData () {
        this.activeProductItem = null
      },

      cancelChangeProductType () {
        this.$bus.$emit('close-modal', 'ChangeProductType')
        this.emptyCancelData()
      },

      cancelConfirmChangeProductType () {
        this.$bus.$emit('close-modal', 'confirmChangeProduct')
        this.emptyCancelData()
      },

      modifyChangeProductType () {
        this.$bus.$emit('open-modal', 'confirmChangeProduct')
        this.$bus.$emit('close-modal', 'ChangeProductType')
      },

      mouseleave () {
        if (this.greyChangeProductType) {
          this.changeProductType = false
        }
      },
      mouseover () {
        if (this.greyChangeProductType) {
          this.changeProductType = true
        }
      }
    },

    tasks (t) {
      return {
        confirmChangeProductTask: t(async function () {
          await Vue.api.subscription.changeReplenishmentType(this.subscriptionNumber, this.activeProductInfo.id)
          this.displayChangeReplenishmentSuccess = {
            display: true,
            name: this.activeProductInfo.name,
            price: this.activeProductInfo.paymentAmount
          }
          this.$bus.$emit('display-change-success-tips', this.displayChangeReplenishmentSuccess)
          await this.$store.dispatch('subscription/fetchSubscriptionDetails', this.subscriptionNumber)
        }).onError(function (task) {
          this.$notify({
            type: 'error',
            title: extractErrorMessage(task.error)
          })
        })
      }
    },

    components: {
      Product
    }
  }
</script>

<style lang="scss">
  .ChangeProductType {
    &_title {
      background: #f5f5f5;
      padding: .12rem .14rem;
      color: #212121;
      font-weight: 500;
      cursor: pointer;

      .grey {
        color: #c4c4c4;
        line-height: .19rem;
        letter-spacing: -.0002rem;
      }
    }

    .v--modal-container {
      padding: .15rem !important;

      @include media(tablet) {
        padding: .24rem !important;
      }
    }

    .v--modal-content {
      .modal-content {
        margin-top: .25rem;

        .modal-button-warpper {
          margin-top: .4rem !important;
          display: flex;
          justify-content: flex-end !important;
        }

        .AppButton {
          width: auto !important;
          background-color: #1474a4;
        }

        .cancel_closeModal {
          background-color: white;
          color: $blue;
          margin-right: .32rem;
          width: auto;

          &:disabled {
            color: white;
          }
        }

        .cancel_openModal {
          width: auto;
          padding: .08rem .15rem;

          @include media(tablet) {
            padding: .08rem .4rem;
          }
        }
      }
    }

    &_productItems {
      ul {
        margin-top: .12rem;

        li {
          text-align: left;
          width: 48%;
          border: .01rem solid #d6d6d6;
          padding: .12rem;
          margin-right: .12rem;
          border-radius: .08rem;
          font-size: .14rem;
          line-height: .18rem;
          color: #212121;
          cursor: pointer;

          img {
            width: 100%;
          }

          .image {
            width: 1.2rem;
            height: 1.2rem;
            padding: .12rem .19rem;
          }

          h4 {
            margin-bottom: 0 !important;
            font-weight: 700;
          }

          p {
            font-weight: 400;
          }

          @include media(tablet) {
            width: 30%;
          }
        }

        li:nth-last-child(1) {
          margin-right: 0;
        }

        .active_product {
          color: #1474a4;
          border: .01rem solid #1474a4;
        }
      }

      &_bottom {
        font-size: .14rem !important;
        line-height: .2rem !important;
        color: #212121;
        font-weight: 400 !important;
        margin-bottom: 0 !important;
      }
    }

    .Product {
      margin-top: .22rem;
      border-radius: .08rem;
      border-color: #e8e8e8;
      padding: .1 !important;

      @include media(tablet) {
        padding: 0 !important;
      }

      .product-summary-title {
        line-height: .2rem;
        font-size: .16rem;
        margin-bottom: .08rem;
      }

      .Product-summary-infos {
        font-size: .14rem;
        line-height: .24rem;
        font-weight: 400;
        display: inline-block;
        width: 50%;
      }

      .Product_popup_description {
        font-size: .14rem;
        line-height: .24rem;
        font-weight: 400;
        color: #d6d6d6;
        display: inline-block;
        width: 41%;
      }

      .Product_popup_description.Product_popup_price {
        font-weight: 700;
        color: #212121;
      }

      .img-holder {
        width: 1.24rem;
        height: 1.24rem;

        @include media(tablet) {
          width: 1.94rem;
          height: 1.93rem;
        }
      }

      .Product_info {
        @include media(tablet) {
          padding: 0 .41rem 0 .2rem;
        }
      }
    }
  }

  .changeProductType_poptip {
    top: -.19rem;
    left: -.1rem;
    position: absolute;
    background: white;
    min-width: 2.09rem;

    @include media(tablet) {
      top: -.19rem;
      left: .18rem;
      position: absolute;
      background: white;
      min-width: 2.26rem;
      display: block;
    }

    .tooltip-arrow {
      left: calc(80% - 9px) !important;

      @include media(tablet) {
        left: calc(87% - 9px) !important;
      }

      @include media(desktop) {
        left: calc(87% - 9px) !important;
      }
    }

    @include media(desktop) {
      display: block;
    }
  }

  .changeOnlyReplenishmentType_poptip {
    top: -.19rem;
    left: -.1rem;
    position: absolute;
    background: white;
    min-width: 2.09rem;

    @include media(tablet) {
      top: -.19rem;
      left: 2.8rem;
      position: absolute;
      background: white;
      min-width: 2.26rem;
      display: block;
    }

    .tooltip-arrow {
      left: calc(80% - 9px) !important;

      @include media(tablet) {
        left: calc(87% - 9px) !important;
      }

      @include media(desktop) {
        left: calc(87% - 9px) !important;
      }
    }

    @include media(desktop) {
      display: block;
    }
  }
</style>
